import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
	Table,
	Button,
	Modal,
	Spin,
	message,
	Icon,
	Divider,
	Input,
	InputNumber,
	TreeSelect,
	Form,
	Select
} from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import {
	fetchContractList,
	exportContract,
	contractAlert,
	changeContractOverAlert,
	changeContractProbationOverAlert,
	initContarctAlert
} from '../../actions/employee-management-actions.js';
import { fetchDepartmentsList } from '../../actions/department-structure-actions.js';
import { fetchEmployeesList,fetchContractReceiveExpireMembers } from '../../actions/employee-management-actions.js';
import contractManagementService from '../../services/EmployeeManagement/contract-management-service.js';
import debounce from 'lodash.debounce';
const FormItem = Form.Item;
const { TreeNode } = TreeSelect;
const { Option } = Select;



class ContractManagement extends React.Component {

	constructor(props) {
		super(props)
		// 使用 debounce 函数来节流 以 避免 onchange事件的频繁触发 导致页面的频繁重绘
		this.fetchUserList = debounce(this.fetchUserList, 800);
	}

	state = {
		members_list:[]
	};
	rowSelection = {


		onChange: (selectedRowKeys, selectedRows) => {

		}
	};


	_fetchDepartmentsList = (params) => {
		this.props.fetchDepartmentsList(params);
	}


	componentWillMount() {
		this.props.fetchContractList();
		var page_current = 1;
		if (sessionStorage.getItem("page")) {
			page_current = parseInt(sessionStorage.getItem("page"));
		}
		this._fetchDepartmentsList(page_current);
		console.log(sessionStorage.getItem("page"));

	}

	componentDidMount() {
		this.fetchUserList();
	}
	componentWillReceiveProps(nextProps) {
		console.log(nextProps);
	}


	fetchUserList = (params) => {
		this.props.fetchEmployeesList(params)
	}
	handleSearchChange = (v) => {
        let params = { real_name: v };
        this.fetchUserList(params)
	}
	
	handleSelectChange = (v) => {
        this.setState({
            groupUser: v
        })
    }

	/*--import--------------*/
	openImportContractModal() {
		this.setState({ importContractModal: true });
	}
	closeImportContractModal() {
		this.setState({ importContractModal: false });
	}
	downloadTemplate = () => {
		let ref = Modal.info({ content: "正在准备需要下载的模板" });
		contractManagementService.downloadTemplate(res => {
			ref.destroy();
			if (res.data.Success) {
				window.open(res.data.Message);
			}
		});
	}
	setUploadedFile = event => {
		this.setState({ uploadedFile: event.target.files[0] });
	}
	importContract = () => {
		if (this.state.uploadedFile) {
			let ref = Modal.info({ content: "正在导入文件, 请稍后..." });
			let formData = new FormData();
			formData.append("uploadedFile", this.state.uploadedFile);
			contractManagementService.importContract(formData, res => {
				ref.destroy();
				if (res.data.Success) {
					message.success('导入文件成功，' + res.data.Message, 4);
					this.setState({ importModal: false });
					this.props.fetchContractList();
					if (res.data.Object) {
						window.open(res.data.Object);
					}
				} else {
					message.error("导入文件失败, " + res.data.Errors[0], 4)
				}
			}, err => message.error("导入文件失败", 4));
		} else {
			message.error("请选择需要导入的文件", 4);
		}
	}





	exportContract() {
		let ref = Modal.info({ content: "正在准备需要下载的文件, 下载文件可能被浏览器阻挡, 请注意！" });
		this.props.exportContract(url => {
			// console.log(url);
			ref.destroy();
			if (url) {
				window.open(url);
			} else {
				message.error('导出失败', 4);
			}
		});
	}
	/*--setting--------------*/
	openSetContractModal() {
		//加载合同设置合同到期前接收提醒人员列表
		this.props.fetchContractReceiveExpireMembers();
		
		this.props.initContarctAlert();
		this.setState({ setContractModal: true });
	}
	closeSetContractModal() {
		this.setState({ setContractModal: false });
	}
	submitSetContractModal() {
		let posts = {
			contract_over_alert: this.props.employeeManagement.contract_over_alert,
			contract_probation_over_alert: this.props.employeeManagement.contract_probation_over_alert,
			group_users:this.state.groupUser
		}
		this.props.contractAlert(posts);
		this.setState({ setContractModal: false });
	}

	/*	contractDetail(text, record, index) {
			console.log(text, record, index);
		}*/
	pageContractList(pagination, filters, sorter) {
		sessionStorage.setItem("page", pagination.current);

		this.props.fetchContractList({ Page: pagination.current, order_property: sorter.field, is_order_asc: sorter.order !== "descend" });
	}


	renderTreeNodes = (data) => {
		return data.map((item) => {
			if (item.children) {
				return (
					<TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
						{item.children.length !== 0 && this.renderTreeNodes(item.children)}
					</TreeNode>
				);
			}
			return <TreeNode {...item} />;
		});
	}

	onSelectTreeChange(ids) {
		let get = { department_ids: ids, Page: 1 }
		this.setState(get);

		console.log(ids)

		// console.log(get)

		this.props.fetchContractList(get);
		//this.props.fetchStaffBirthdayList(get)
	}


	render() {

		const { departmentsList } = this.props.departmentStructure;

		const { getFieldDecorator } = this.props.form;

		const { employeeList} = this.props.employeeManagement;
		
		const{members_list}=this.props.employeeManagement;

		

		let defaultGroupUserIds =members_list? members_list.Data.map(i=>i.employee_id):[]
		let defaultGroupUsers=members_list?members_list.Data.map(i=>{ return {id:i.employee_id,real_name:i.name}}):[]

		let employeeListData = employeeList ? employeeList.Data.concat(defaultGroupUsers) : [];
		
		const contractColumn = [

			{ title: '工号', dataIndex: 'job_number', className: 'certificate-head-class', sorter: true },
			{ title: '姓名', dataIndex: 'real_name', className: 'certificate-head-class', sorter: true },
			{ title: '英文名', dataIndex: 'english_name', className: 'certificate-head-class', sorter: true },
			{ title: '部门', dataIndex: 'department_name', className: 'certificate-head-class', sorter: true },
			{ title: '职位', dataIndex: 'position_name', className: 'certificate-head-class', sorter: true },
			{ title: '合同类型', dataIndex: 'type_name', className: 'certificate-head-class', sorter: true },

			{ title: '合同初签时间', dataIndex: 'first_start_date', className: 'certificate-head-class', sorter: true },
			{ title: '合同续签时间', dataIndex: 'start_date', className: 'certificate-head-class', sorter: true },
			{ title: '合同到期日', dataIndex: 'end_date', className: 'certificate-head-class', sorter: true },

			{ title: '试用期到期日', dataIndex: 'probation_end_date', className: 'certificate-head-class', sorter: true },
			{ title: '签订次数', dataIndex: 'counter', className: 'certificate-head-class', sorter: true },

			{
				title: '操作', dataIndex: 'action', className: 'certificate-head-class', render: (text, record, index) => this.props.access.contractManagement.u_value &&
					<span>
						<span title="查看">
							<Link to={"/employee/contract-management/" + record.employee_id}>
								{/*	<Icon className="icon-hover-pointer" style={{fontSize:"16px",margin:"0px 4px",color:"blue"}} type="edit" />*/}
								<Button icon="eye-o" size="small" className="row-action-btn">查看</Button>
							</Link>
						</span>
					</span>
			}
		];
		return (
			<div className="app-module-item">
				<div className="colAction">
					{this.props.access.contractManagement.import_value && <span><Button type="primary" onClick={this.openImportContractModal.bind(this)}>
						<Icon type="cloud-upload-o" />
						<span>导入</span>
					</Button>
						<Divider type="vertical" /></span>}
					{this.props.access.contractManagement.export_value && <span><Button type="primary" onClick={this.exportContract.bind(this)}>
						<Icon type="cloud-download-o" />
						<span>导出</span>
					</Button>
						<Divider type="vertical" /></span>}
					{this.props.access.contractManagement.set_value && <Button type="primary" onClick={this.openSetContractModal.bind(this)}>
						<Icon type="setting" />
						<span>合同设置</span>
					</Button>}

					{
						departmentsList ?
							<div style={{ float: 'right', margin: '15px 5px 0px' }}>
								<span style={{ float: 'left', height: "40px", lineHeight: "40px", marginRight: "5px" }}>部门 : </span>

								<Form layout="inline" style={{ float: 'left' }}>
									<FormItem>
										{getFieldDecorator('department_id')(
											<TreeSelect style={{ minWidth: "300px", marginBottom: '15px' }}
												multiple
												placeholder="请选择部门"
												showSearch={false}
												autoExpandParent={true}
												dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
												treeDefaultExpandAll

												onChange={this.onSelectTreeChange.bind(this)}
											>
												{this.renderTreeNodes(departmentsList)}
											</TreeSelect>
										)}
									</FormItem>
								</Form>


							</div>
							:
							<Spin />
					}

				</div>
				{this.props.employeeManagement.constractList ?
					<Table rowSelection={this.rowSelection} columns={contractColumn}
						dataSource={this.props.employeeManagement.constractList}
						scroll={{ x: 600 }}
						rowKey={record => record.employee_id}
						pagination={{
							total: this.props.employeeManagement.constractTotal,
							pageSize: this.props.employeeManagement.constractPageSize,
							current: this.props.employeeManagement.constractPage,
							defaultCurrent: 1
						}}
						onChange={this.pageContractList.bind(this)} />
					: <div style={{ textAlign: 'center', margin: '100px 0px' }}><Spin size="large" /></div>}
				<Modal width="800px"
					visible={this.state.importContractModal}
					title="合同导入"
					destroyOnClose={true}
					onCancel={this.closeImportContractModal.bind(this)}
					footer={<Button type="back" onClick={this.closeImportContractModal.bind(this)}>关闭</Button>}>
					<div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
						<div>
							<Button type="primary" onClick={this.downloadTemplate}>
								<Icon type="cloud-download-o" />
								<span>下载模板</span>
							</Button>
						</div>
						<div style={{ marginTop: "40px" }}>
							<div>导入文件</div>
							<Input type="file" style={{ height: "38px" }} onChange={this.setUploadedFile} />
							<Button type="primary" style={{ marginTop: "20px" }} onClick={this.importContract}>
								<Icon type="cloud-upload-o" />
								<span>开始导入</span>
							</Button>
						</div>
					</div>
				</Modal>
				{/*				<Modal width="800px"
					visible={this.state.exportContractModal}
					title="合同导出"
					destroyOnClose={true}
					onCancel={this.closeExportContractModal.bind(this)}
					footer={<Button type="back" onClick={this.closeExportContractModal.bind(this)}>关闭</Button>}>
					<div style={{textAlign:"center",margin:"20px 0px 20px"}}>
						<Button type="primary" onClick={this.exportContract.bind(this)}>
							<Icon type="cloud-download-o" />
							<span>开始导出</span>
						</Button>
					</div>
				</Modal>*/}




				<Modal width="800px"
					visible={this.state.setContractModal}
					title="合同设置"
					destroyOnClose={true}
					onCancel={this.closeSetContractModal.bind(this)}
					onOk={this.submitSetContractModal.bind(this)}>
					<div style={{ textAlign: "center", margin: "20px 0px 20px" }}>
						<div style={{ margin: "15px" }}>
							<span>试用期转正预警通知: 提前</span>
							<InputNumber min={0} step={1} style={{ margin: "0px 10px" }} ref="contract_probation_over_alert"
								onChange={this.props.changeContractProbationOverAlert.bind(this)}
								value={this.props.employeeManagement.contract_probation_over_alert} />
							<span>天预警</span>
						</div>
						<div style={{ margin: "15px" }}>
							<span>合同到期预警通知: 提前</span>
							<InputNumber min={0} step={1} style={{ margin: "0px 10px" }} ref="contract_over_alert"
								onChange={this.props.changeContractOverAlert.bind(this)}
								value={this.props.employeeManagement.contract_over_alert} />
							<span>天预警</span>
						</div>
						<div style={{ margin: "15px" }}>
							<span>合同到期前接收提醒人员:</span>
							<Select
								style={{ margin: "0px 10px", width: "250px" }}
								mode="multiple"
								placeholder="选择人员"
								 onSearch={this.handleSearchChange}
								onChange={this.handleSelectChange}
								notFoundContent={<Spin size="small" />}
								filterOption={false}
							 defaultValue={ defaultGroupUserIds }
							>
								{
									employeeListData.map(i => <Option key={i.id} value={i.id}>{i.real_name}</Option>)
						}
							</Select>
						</div>
					</div>
				</Modal>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		employeeManagement: state.employeeManagement,
		departmentStructure: state.departmentStructure
	}
}
const mapDispatchToProps = {
	fetchContractList,
	initContarctAlert,
	exportContract,
	contractAlert,
	changeContractProbationOverAlert,
	changeContractOverAlert,
	fetchDepartmentsList,
	fetchEmployeesList,
	fetchContractReceiveExpireMembers
}
ContractManagement = Form.create()(ContractManagement)
export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(ContractManagement));


// WEBPACK FOOTER //
// ./src/routes/EmployeeManagement/ContractManagement.js